import type { JSX } from 'react'

export const SendIcon = (): JSX.Element => (
  <use href='#sendIcon' height='100%' width='100%' />
)
